var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "section",
    {
      staticClass: "model-item",
      attrs: { "data-id": this.data.shopProductId },
    },
    [
      _c(
        "button",
        {
          staticClass: "deleteItem",
          on: {
            click: function ($event) {
              return _vm.deleteItems()
            },
          },
        },
        [
          _c("svg", { attrs: { fill: "#000", viewBox: "0 0 128 128" } }, [
            _c("g", { attrs: { "clip-path": "url(#clip0_1346_297)" } }, [
              _c("rect", {
                attrs: { width: "128", height: "128", fill: "white" },
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d: "M77.8662 102.436L79.9891 45.0293L86.7941 45.2773L84.6614 102.684L77.8662 102.436Z",
                  fill: "#0F0F0F",
                },
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d: "M60.1279 45.1426H66.933V102.579H60.1279V45.1426Z",
                  fill: "#0F0F0F",
                },
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d: "M40.2793 45.2539L47.0844 45.0059L49.1874 102.432L42.3922 102.68L40.2793 45.2539Z",
                  fill: "#0F0F0F",
                },
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d: "M26.6174 127.971C25.7647 127.976 24.9414 127.659 24.3123 127.083C23.6832 126.508 23.2948 125.716 23.2248 124.866L14.5746 26.5492H4V19.7441H123.039V26.5492H112.276L103.626 124.895C103.556 125.745 103.167 126.537 102.538 127.113C101.909 127.689 101.086 128.006 100.233 128L26.6174 127.971ZM29.7224 121.166H97.1283L105.451 26.5492H21.4095L29.7224 121.166Z",
                  fill: "#0F0F0F",
                },
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d: "M80.3662 21.3874V6.80508H46.6384V21.3874H39.8731V6.83484C39.8717 5.93691 40.0476 5.04755 40.3907 4.21772C40.7337 3.38789 41.2371 2.6339 41.872 1.99897C42.507 1.36404 43.2609 0.860638 44.0908 0.517618C44.9206 0.174598 45.81 -0.00129886 46.7079 7.22041e-06H80.3464C81.2443 -0.00129886 82.1337 0.174598 82.9635 0.517618C83.7933 0.860638 84.5473 1.36404 85.1822 1.99897C85.8172 2.6339 86.3206 3.38789 86.6636 4.21772C87.0066 5.04755 87.1825 5.93691 87.1812 6.83484V21.3874H80.3662Z",
                  fill: "#0F0F0F",
                },
              }),
            ]),
            _vm._v(" "),
            _c("defs", [
              _c("clipPath", { attrs: { id: "clip0_1346_297" } }, [
                _c("rect", {
                  attrs: { width: "128", height: "128", fill: "white" },
                }),
              ]),
            ]),
          ]),
        ]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "item-header" }, [
        _c(
          "a",
          { staticClass: "link-wrap", attrs: { href: this.data.pageUrl } },
          [
            _c("img", {
              staticClass: "product-image",
              attrs: {
                src: this.data.medias[0].path,
                alt: this.data.title,
                loading: "lazy",
              },
            }),
            _vm._v(" "),
            _c("div", { staticClass: "container" }, [
              _c("p", { staticClass: "short-description" }, [
                _vm._v(_vm._s(this.data.subtitle)),
              ]),
              _vm._v(" "),
              _c("h2", [_vm._v(_vm._s(this.data.title))]),
            ]),
          ]
        ),
        _vm._v(" "),
        this.data.functions.length > 0
          ? _c("div", { staticClass: "model-attributes" }, [
              this.data.functions.length > 0
                ? _c(
                    "div",
                    _vm._l(
                      this.data.functions[0].medias,
                      function (attribute, i) {
                        return _c("div", { key: i, staticClass: "attribute" }, [
                          _c("img", {
                            attrs: {
                              src: attribute.path,
                              alt: "attribute icon",
                              loading: "lazy",
                            },
                          }),
                        ])
                      }
                    ),
                    0
                  )
                : _c("div", { staticClass: "hidden" }, [
                    _c("svg", { attrs: { viewBox: "0 0 36.936 30.695" } }, [
                      _c("path", {
                        attrs: {
                          id: "glatz-icon-ueberwinterung",
                          d: "M25.8,48.807H24.272V46.955a.379.379,0,0,0-.378-.378H21.455V41.7a1.74,1.74,0,0,0,1.21-1.72V38.751a1.74,1.74,0,0,0-1.21-1.72v-9.15h.983l.113-.737-1.437.019h-.076l-13.724.076L7.277,27.2a10.056,10.056,0,0,0-1.853-1.871,7.145,7.145,0,0,0-1.418-.586L3.893,24.7a4.685,4.685,0,0,1-.775-.284c.057-.17.076-.208.624-.34.756-.17,10.246-2.571,17.146-4.386.435.095,2.42.567,4.877,1.115a4.862,4.862,0,0,1,.624-.624c-2.836-.662-5.161-1.191-5.407-1.248a.262.262,0,0,0-.17,0c-6.9,1.815-16.446,4.216-17.222,4.4-.586.151-.926.265-1.134.794a.785.785,0,0,0,0,.586c.17.359.6.492,1.267.681l.095.038a5.542,5.542,0,0,1,1.248.51,9.36,9.36,0,0,1,1.664,1.682l.151.189a.344.344,0,0,0,.3.151h.057L20.756,27.9v9.168a1.74,1.74,0,0,0-1.21,1.72v1.229a1.74,1.74,0,0,0,1.21,1.72v4.877H18.128a.379.379,0,0,0-.378.378v1.853H16.2a.392.392,0,0,0-.378.378.379.379,0,0,0,.378.378l7.694.019L25.8,49.6a.352.352,0,0,0,.359-.378.365.365,0,0,0-.359-.416ZM20.245,40V38.769a1.013,1.013,0,0,1,.6-.983.519.519,0,0,1,.246-.038,1.107,1.107,0,0,1,.246.038,1.032,1.032,0,0,1,.6.983V40a1.054,1.054,0,0,1-.473.926.73.73,0,0,1-.718,0A1.026,1.026,0,0,1,20.245,40Zm3.289,8.809H18.487V47.333h5.028v1.475Zm-2.42-21.664h0ZM31.72,36.482a.339.339,0,0,1-.34-.34V33.287L29.3,35.1a.349.349,0,0,1-.227.095.269.269,0,0,1-.227-.113.339.339,0,0,1-.095-.246.261.261,0,0,1,.113-.208l2.514-2.193v-1.55l-1.021-.6-1.04-.586-1.342.775-.643,3.27a.341.341,0,0,1-.321.265h-.076a.293.293,0,0,1-.208-.151.36.36,0,0,1-.038-.246l.529-2.7-2.439,1.418a.552.552,0,0,1-.17.038.312.312,0,0,1-.284-.17.416.416,0,0,1-.038-.265.3.3,0,0,1,.151-.189l2.439-1.418-2.609-.888a.332.332,0,0,1-.189-.17.316.316,0,0,1,.284-.454.142.142,0,0,1,.095.019l3.157,1.1L29.244,29H28.96v-2.25l-1.342-.775-3.157,1.1a.206.206,0,0,1-.095.019.445.445,0,0,1-.151-.038L24.2,27.03a.381.381,0,0,1-.132-.17.243.243,0,0,1,.019-.227.414.414,0,0,1,.189-.17l2.609-.888-2.439-1.418a.3.3,0,0,1-.151-.189.28.28,0,0,1,.038-.246.333.333,0,0,1,.284-.151.552.552,0,0,1,.17.038l2.458,1.418-.529-2.7a.341.341,0,0,1,.246-.4h.076a.341.341,0,0,1,.321.265L28,25.461l1.342.775,2.042-1.191V23.5l-2.287-2-.208-.189a.322.322,0,0,1,.208-.567.463.463,0,0,1,.227.076l.265.246,1.191,1.021.6.529V19.771a.34.34,0,1,1,.681,0v2.873l.265-.227.019-.019,1.777-1.569a.349.349,0,0,1,.227-.095.333.333,0,0,1,.246.113.313.313,0,0,1,.095.246.261.261,0,0,1-.113.208l-2.552,2.174v1.531L34.064,26.2l1.342-.775.454-2.306.151-.718.038-.246a.341.341,0,0,1,.321-.265h.076a.293.293,0,0,1,.208.151.36.36,0,0,1,.038.246l-.529,2.722L38.6,23.59a.281.281,0,0,1,.17-.038.312.312,0,0,1,.284.17.345.345,0,0,1-.057.416c-.019.019-.038.038-.057.038L36.5,25.593l2.609.888a.332.332,0,0,1,.189.17.369.369,0,0,1,.019.246.324.324,0,0,1-.3.227.142.142,0,0,1-.095-.019l-2.061-.7-1.1-.378-1.342.775v2.4l1.342.775L38.922,28.9a.206.206,0,0,1,.095-.019.324.324,0,0,1,.3.227.319.319,0,0,1-.208.4l-2.609.888,2.439,1.418a.3.3,0,0,1,.151.189.378.378,0,0,1-.038.246.351.351,0,0,1-.284.17.552.552,0,0,1-.17-.038l-2.439-1.456.529,2.7a.36.36,0,0,1-.038.246.4.4,0,0,1-.208.151H36.37a.341.341,0,0,1-.321-.265l-.643-3.27-1.342-.775-2.042,1.191v1.55l2.533,2.193a.322.322,0,0,1-.208.567.537.537,0,0,1-.227-.076l-2.079-1.815v2.836a.331.331,0,0,1-.321.321ZM30.643,26.16l-1.021.586v2.382l1.021.6,1.04.6L33.7,29.147V26.765l-1-.586-1.04-.6Z",
                          transform: "translate(-2.4 -18.925)",
                        },
                      }),
                    ]),
                    _vm._v(" "),
                    _vm._m(0),
                  ]),
            ])
          : _vm._e(),
      ]),
      _vm._v(" "),
      _vm._m(1),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "specs" },
        [
          _c(
            "ItemSpecification",
            { attrs: { data: this.data, topic: "dimensions" } },
            [_vm._v(_vm._s(_vm.t("compare.dimensions")))]
          ),
          _vm._v(" "),
          _c(
            "ItemSpecification",
            { attrs: { data: this.data, topic: "quality" } },
            [_vm._v(_vm._s(_vm.t("compare.quality")))]
          ),
          _vm._v(" "),
          _c(
            "ItemSpecification",
            { attrs: { data: this.data, topic: "accessories" } },
            [_vm._v(_vm._s(_vm.t("compare.accessories")))]
          ),
        ],
        1
      ),
      _vm._v(" "),
      _vm._m(2),
      _vm._v(" "),
      _c(
        "ItemFooter",
        { attrs: { data: this.data } },
        [_vm._t("button-label")],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "attribute-hint" }, [
      _c("p", [_vm._v("#1 Test Test")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "divider" }, [_c("hr")])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "divider" }, [_c("hr")])
  },
]
render._withStripped = true

export { render, staticRenderFns }